import styled from 'styled-components';
import { Button } from 'Components/ui';

export const ClearButton = styled(Button)`
  height: 40px;
  width: fit-content;
  padding: 10px 24px;
  text-transform: none;
`;

export const FilterButton = styled(Button)`
  height: 40px;
  width: fit-content;
  padding: 10px 24px;
  text-transform: none;
`;

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
`;

